import { render } from "./ProductHome.vue?vue&type=template&id=7ca5342a"
import script from "./ProductHome.vue?vue&type=script&lang=js"
export * from "./ProductHome.vue?vue&type=script&lang=js"
script.render = render

export default script